import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { TrialInformation } from "../models/trial-info/trial-information.model";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class TrialInfoService {
  private readonly endpoint = environment.apiUrl + '/trialinfo';
  constructor(private _http: HttpClient) { }
  /**
   * Updates trial information for a given trial ID.
   * @param trialId
   * @param trialInfo
   */
  updateTrialInformation(trialId: string, trialInfo: TrialInformation) {
    return this._http.post<TrialInformation>(this.endpoint + '/' + trialId, trialInfo).pipe(map(rsp => new TrialInformation(rsp)));
  }
  /**
   * Retrieves trial information for a given trial ID.
   * @param trialId
   */
  getTrialInformation(trialId: string) {
    return this._http.get<TrialInformation>(this.endpoint + '/' + trialId).pipe(map(rsp => new TrialInformation(rsp)));
  }
}
